import React, { useEffect, useState } from 'react';
import Swal from 'sweetalert2';
import baseURL from '../../url';
import './PacientesData.css';

export default function NewPaciente({ paciente = {}, cerrarModal, recargar }) {
    const [loading, setLoading] = useState(false);
    const [zoomImg, setZoomImg] = useState(null);

    const [nombre, setNombre] = useState(paciente.nombre || '');
    const [direccion, setDireccion] = useState(paciente.direccion || '');
    const [telefono, setTelefono] = useState(paciente.telefono || '');
    const [fechaNacimiento, setFechaNacimiento] = useState(paciente.fecha_nacimiento || '');
    const [email, setEmail] = useState(paciente.email || '');
    const [sexo, setSexo] = useState(paciente.sexo || 'Hombre');
    const [categoriaId, setCategoriaId] = useState(paciente.categoria_id || '');
    const [categorias, setCategorias] = useState([]);

    const [fotosAntes, setFotosAntes] = useState([null, null, null, null]);
    const [fotosDespues, setFotosDespues] = useState([null, null, null, null]);

    const [previewsAntes, setPreviewsAntes] = useState([null, null, null, null]);
    const [previewsDespues, setPreviewsDespues] = useState([null, null, null, null]);

    useEffect(() => {
        cargarCategorias();

        if (paciente.id) {
            const arrAntes = [
                paciente.foto_antes_1,
                paciente.foto_antes_2,
                paciente.foto_antes_3,
                paciente.foto_antes_4
            ];
            const arrDespues = [
                paciente.foto_despues_1,
                paciente.foto_despues_2,
                paciente.foto_despues_3,
                paciente.foto_despues_4
            ];

            // Previews para mostrar imágenes existentes
            setPreviewsAntes(arrAntes.map(f => f ? `${baseURL}/imagenes_pacientes/${f}` : null));
            setPreviewsDespues(arrDespues.map(f => f ? `${baseURL}/imagenes_pacientes/${f}` : null));

            // Guardamos nombres actuales para enviar al backend si no se reemplazan
            setFotosAntes(arrAntes);
            setFotosDespues(arrDespues);
        }
    }, [paciente]);

    const cargarCategorias = () => {
        fetch(`${baseURL}/categoriasGet.php`)
            .then(res => res.json())
            .then(data => setCategorias(data.categorias || []))
            .catch(err => console.error(err));
    };

    const handleFotoChange = (index, tipo, file) => {
        if (!file) return;
        const previewURL = URL.createObjectURL(file);

        if (tipo === 'antes') {
            const newFotos = [...fotosAntes];
            const newPreviews = [...previewsAntes];
            newFotos[index] = file; // Reemplaza archivo existente
            newPreviews[index] = previewURL;
            setFotosAntes(newFotos);
            setPreviewsAntes(newPreviews);
        } else {
            const newFotos = [...fotosDespues];
            const newPreviews = [...previewsDespues];
            newFotos[index] = file; // Reemplaza archivo existente
            newPreviews[index] = previewURL;
            setFotosDespues(newFotos);
            setPreviewsDespues(newPreviews);
        }
    };

    const handleZoom = (url) => setZoomImg(url);
    const cerrarZoom = () => setZoomImg(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        const formData = new FormData();
        if (paciente.id) formData.append('id', paciente.id);
        formData.append('nombre', nombre);
        formData.append('direccion', direccion);
        formData.append('telefono', telefono);
        formData.append('fecha_nacimiento', fechaNacimiento);
        formData.append('email', email);
        formData.append('sexo', sexo);
        formData.append('categoria_id', categoriaId);

        // Fotos Antes
        fotosAntes.forEach((file, i) => {
            if (file instanceof File) formData.append(`foto_antes_${i + 1}`, file);
            else formData.append(`foto_antes_${i + 1}_existente`, file);
        });

        // Fotos Después
        fotosDespues.forEach((file, i) => {
            if (file instanceof File) formData.append(`foto_despues_${i + 1}`, file);
            else formData.append(`foto_despues_${i + 1}_existente`, file);
        });

        try {
            const res = await fetch(`${baseURL}/pacientesPost.php`, {
                method: 'POST',
                body: formData,
            });
            const data = await res.json();
            if (data.error) Swal.fire('Error', data.error, 'error');
            else {
                Swal.fire('Éxito', data.mensaje, 'success');
                cerrarModal();
                recargar();
            }
        } catch (err) {
            Swal.fire('Error', err.message, 'error');
        } finally {
            setLoading(false);
        }
    };

    const renderFotosTable = (previews, tipo) => (
        <table className="fotos-table">
            <tbody>
                <tr>
                    {previews.map((p, i) => (
                        <td key={i}>
                            {p && 
                                <img 
                                    onClick={() => handleZoom(p)}
                                    style={{ cursor: 'pointer' }}
                                    src={p} alt={`${tipo} ${i + 1}`} className="preview-img" />}
                        </td>
                    ))}
                </tr>
                <tr>
                    {previews.map((_, i) => (
                        <td key={i}>
                            <input type="file" accept="image/*" onChange={e => handleFotoChange(i, tipo, e.target.files[0])} />
                        </td>
                    ))}
                </tr>
            </tbody>
        </table>
    );

    return (
        <div className="modal">
            <div className="modal-content">
                <span className="close" onClick={cerrarModal}>&times;</span>
                <h3>{paciente.id ? 'Editar Paciente' : 'Nuevo Paciente'}</h3>
                <form onSubmit={handleSubmit} className="form-paciente">

                    <label>Nombre</label>
                    <input type="text" value={nombre} onChange={e => setNombre(e.target.value)} required />

                    <label>Dirección</label>
                    <input type="text" value={direccion} onChange={e => setDireccion(e.target.value)} />

                    <label>Teléfono</label>
                    <input type="text" value={telefono} onChange={e => setTelefono(e.target.value)} />

                    <label>Email</label>
                    <input type="email" value={email} onChange={e => setEmail(e.target.value)} />

                    <label>Fecha de Nacimiento</label>
                    <input type="date" value={fechaNacimiento} onChange={e => setFechaNacimiento(e.target.value)} />

                    <label>Sexo</label>
                    <select value={sexo} onChange={e => setSexo(e.target.value)}>
                        <option>Hombre</option>
                        <option>Mujer</option>
                        <option>Binario</option>
                    </select>

                    <label>Categoría</label>
                    <select value={categoriaId} onChange={e => setCategoriaId(e.target.value)}>
                        <option value="">Seleccione categoría</option>
                        {categorias.map(cat => (
                            <option key={cat.idCategoria} value={cat.idCategoria}>{cat.categoria}</option>
                        ))}
                    </select>

                    <label>Fotos Antes</label>
                    {renderFotosTable(previewsAntes, 'antes')}

                    <label>Fotos Después</label>
                    {renderFotosTable(previewsDespues, 'despues')}

                    <button type="submit" className="btn btn-add" disabled={loading}>
                        {loading ? 'Cargando...' : (paciente.id ? 'Actualizar' : 'Crear')}
                    </button>
                </form>
            </div>

            {zoomImg && (
                <div className="zoom-modal" onClick={cerrarZoom}>
                    <img src={zoomImg} alt="Zoom" className="zoom-img" />
                </div>
            )}
        </div>
    );
}
